angular.module('elfium').filter('elfiumGetNumber', function () {
    return function (inputValue) {
        return Number(inputValue) || 0;
    };
});


// WEBPACK FOOTER //
// ./src/app/components/elfium/elfiumGetNumberFilter.ts